import { FC } from 'react';

import { ICommonResponse } from 'api/types';
import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionJobs } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { IEntity } from 'types';
import { getAcademicYearByDate, getDataLoadRequests, isDateValid } from 'utils';

import { professionJobsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const splitJobByAcademicYear = (data: ICommonResponse<IEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IEntity[]> = {};

  data.content.forEach((item) => {
    // Если не задана дата контракта, то выставляем последний (текущий) учебный год
    const date = item?.formData?.contract?.date ? new Date(item.formData.contract.date) : new Date();
    if (isDateValid(date)) {
      const period = getAcademicYearByDate(date);
      if (academicYears.includes(period)) {
        if (learningYearData[period]) {
          learningYearData[period].push(item);
        } else {
          learningYearData[period] = [item];
        }
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};

const PdfJobsContainer: FC = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const jobs = useAppSelector(professionJobsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionJobs });

  const hasData = jobs.content.length > 0;

  const academicYearData = splitJobByAcademicYear(jobs, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Трудоустройство" Icon={IconWidgetProfessionJobs}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfJobsContainer;
